import { Step, Stepper, useStepper } from "@/components/stepper";
import { FeatureGuard } from "@/features/auth/permissions/feature-guard.tsx";
import { BrandsForm } from "@/features/brands/components/BrandsForm";

import { useBrandCreationFlow } from "./hooks/useBrandCreationFlow";
import { BasicInfo } from "./sessions/basicInfo";
import { BrandFinishCreation } from "./sessions/brandFinishCreation";
import { BrandGuidelines } from "./sessions/brandGuidelines";

function BrandsStepperContent() {
  const stepper = useStepper();
  const { handleStep1Next, handleStep2Next } = useBrandCreationFlow(stepper);

  return (
    <>
      {stepper.step < 3 && (
        <div className="hidden md:flex text-[16px] font-light justify-end w-full max-w-[40rem] -mb-[40px] mt-[10px] text-text-primary z-10 relative">
          <span>{stepper.step}/2</span>
        </div>
      )}

      <div className="relative w-full overflow-hidden min-h-[400px]">
        <Step id={1}>
          <BasicInfo onNext={handleStep1Next} />
        </Step>

        <Step id={2}>
          <BrandGuidelines onBack={stepper.prevStep} onNext={handleStep2Next} />
        </Step>

        <Step className="flex flex-col w-full gap-4 h-full" id={3}>
          <BrandFinishCreation />
        </Step>
      </div>
    </>
  );
}

export function CreateBrandPage() {
  return (
    <FeatureGuard feature="create-brand">
      <div className="flex flex-col w-full px-[1.75rem] md:px-0">
        <Stepper totalSteps={3} withProgressBar>
          <BrandsForm>
            <BrandsStepperContent />
          </BrandsForm>
        </Stepper>
      </div>
    </FeatureGuard>
  );
}
